import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import {DashboardModule} from '@/util/dashboard';
import {PropType, computed} from 'vue';
import AppDashboardModule from './AppDashboardModule.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDashboard',
  props: {
  modules: {
    type: Array as PropType<DashboardModule[]>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const filteredModules = computed(() => props.modules.filter((mod) => !mod.hideInNav));

__expose({
  AppDashboardModule,
  filteredModules,
});

return (_ctx: any,_cache: any) => {
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (filteredModules.value.length > 0)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        dense: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modules, (mod) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: mod.name
            }, [
              (!mod.hideInNav)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    sm: "6",
                    lg: "4",
                    xl: "3"
                  }, {
                    default: _withCtx(() => [
                      (mod.badgeContent)
                        ? (_openBlock(), _createBlock(_component_v_badge, {
                            key: 0,
                            content: mod.badgeContent,
                            color: "error-darken-1",
                            class: "btn-card",
                            bordered: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(AppDashboardModule, { mod: mod }, null, 8, ["mod"])
                            ], undefined, true),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createBlock(AppDashboardModule, {
                            key: 1,
                            mod: mod
                          }, null, 8, ["mod"]))
                    ], undefined, true),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], undefined, true),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_alert, {
        key: 1,
        type: "info"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Es sind keine Module verfügbar ")
        ], undefined, true),
        _: 1
      }))
}
}

})